import React, { useEffect, useState } from "react"
import { Button, TextInputField, DropDownField, TextAreaField } from '../../../helpers'

const StructuredCommentModel = (props) => {
    const { lastCommentStructure, subCategoryId, setShowStructuredCommentModel, addComment, addCommentTriggered, editTicket } = props

    const [filteredCommentStructure, setFilteredCommentStructure] = useState([])
    const [formData, setFormData] = useState({})
    const [errors, setErrors] = useState({})

    useEffect(() => {
        if (lastCommentStructure) {
            const filteredStructure = lastCommentStructure.filter(each => each.ticketSubcategoryId === subCategoryId)
            if (filteredStructure.length > 0) {
                setFilteredCommentStructure(filteredStructure)
            }
        }
    }, [lastCommentStructure, subCategoryId])

    const handleChange = (label, value, isMandatory, elementType) => {
        const lowerElementType = elementType.toLowerCase()
        let errorMessage = ''
    
        setFormData(prevData => ({
            ...prevData,
            [label]: value
        }))
    
        if (isMandatory && !value) {
            errorMessage = `${label} is required`
        }
        else if (['int', 'docno', 'reqno', 'buyerpono', 'sellerpono', 'sellerpino', 'vpno', 'buyerinvoiceno'].includes(lowerElementType)) {
            if (isNaN(value)) {
                errorMessage = `${label} must be numeric`
            } else {
                switch (lowerElementType) {
                    case 'docno':
                        if (![11, 15, 16].includes(value.length)) {
                            errorMessage = `${label} should be either 11, 15, or 16 digits`
                        }
                        break
                    case 'reqno':
                        if (!value.startsWith("11")) {
                            errorMessage = `${label} must start with 11`
                        } else if (value.length !== 15) {
                            errorMessage = `${label} should be exactly 15 digits`
                        }
                        break
                    case 'buyerpono':
                        if (!value.startsWith("14")) {
                            errorMessage = `${label} must start with 14`
                        } else if (value.length !== 15) {
                            errorMessage = `${label} should be exactly 15 digits`
                        }
                        break
                    case 'sellerpono':
                        if (!value.startsWith("15")) {
                            errorMessage = `${label} must start with 15`
                        } else if (value.length !== 15) {
                            errorMessage = `${label} should be exactly 15 digits`
                        }
                        break
                    case 'sellerpino':
                        if (!value.startsWith("16")) {
                            errorMessage = `${label} must start with 16`
                        } else if (value.length !== 15) {
                            errorMessage = `${label} should be exactly 15 digits`
                        }
                        break
                    case 'vpno':
                        if (!value.startsWith("19")) {
                            errorMessage = `${label} must start with 19`
                        } else if (value.length !== 15) {
                            errorMessage = `${label} should be exactly 15 digits`
                        }
                        break
                    case 'buyerinvoiceno':
                        if (!value.startsWith("20")) {
                            errorMessage = `${label} must start with 20`
                        }
                        break
                    default:
                        break
                }
            }
        }
    
        setErrors(prevErrors => ({
            ...prevErrors,
            [label]: errorMessage
        }))
    }

    const validateForm = () => {
        const newErrors = {}
        filteredCommentStructure.forEach(item => {
            const label = item.elementName.charAt(0).toUpperCase() + item.elementName.slice(1)
            const value = formData[label]
            const lowerElementType = item.elementType.toLowerCase()

            if (item.mandatory && (!value || value.toString().trim() === '')) {
                newErrors[label] = `This field is required.`
            }
            else if (['int', 'docno', 'reqno', 'buyerpono', 'sellerpono', 'sellerpino', 'vpno', 'buyerinvoiceno'].includes(lowerElementType)) {
                if (!value || isNaN(value)) {
                    newErrors[label] = `${label} must be numeric`
                } else {
                    switch (lowerElementType) {
                        case 'docno':
                            if (![11, 15, 16].includes(value.length)) {
                                newErrors[label] = `${label} should be either 11, 15, or 16 digits`
                            }
                            break
                        case 'reqno':
                            if (!value.startsWith("11")) {
                                newErrors[label] = `${label} must start with 11`
                            } else if (value.length !== 15) {
                                newErrors[label] = `${label} should be exactly 15 digits`
                            }
                            break
                        case 'buyerpono':
                            if (!value.startsWith("14")) {
                                newErrors[label] = `${label} must start with 14`
                            } else if (value.length !== 15) {
                                newErrors[label] = `${label} should be exactly 15 digits`
                            }
                            break
                        case 'sellerpono':
                            if (!value.startsWith("15")) {
                                newErrors[label] = `${label} must start with 15`
                            } else if (value.length !== 15) {
                                newErrors[label] = `${label} should be exactly 15 digits`
                            }
                            break
                        case 'sellerpino':
                            if (!value.startsWith("16")) {
                                newErrors[label] = `${label} must start with 16`
                            } else if (value.length !== 15) {
                                newErrors[label] = `${label} should be exactly 15 digits`
                            }
                            break
                        case 'vpno':
                            if (!value.startsWith("19")) {
                                newErrors[label] = `${label} must start with 19`
                            } else if (value.length !== 15) {
                                newErrors[label] = `${label} should be exactly 15 digits`
                            }
                            break
                        case 'buyerinvoiceno':
                            if (!value.startsWith("20")) {
                                newErrors[label] = `${label} must start with 20`
                            }
                            break
                        default:
                            break
                    }
                }
            }
        })

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const submitOnPressEnter = (e) => {
        if (e.key === 'Enter') {
            handleSubmit()
        }
    }

    const handleSubmit = () => {
        if (validateForm()) {
            const constructedComment = constructLastComment()
            setShowStructuredCommentModel(false)
            if (addCommentTriggered) {
                addComment(constructedComment)
            } else {
                editTicket(constructedComment)
            }
        }
    }

    const constructLastComment = () => {
        return Object.keys(formData).map((key) => `${key}: ${formData[key]}`).join(', ')
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }} onKeyDown={submitOnPressEnter}>
            {filteredCommentStructure.map((item, index) => {
                const label = item.elementName.charAt(0).toUpperCase() + item.elementName.slice(1)
                const dropdownList = item.dropdownValues

                return (
                    <div key={`comment-${index}`} style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <div style={{ flex: '1 1 100%', margin: '10px', maxWidth: '600px' }}>
                            {item.elementType === 'dropdown' ? (
                                <DropDownField
                                    labelText={label}
                                    options={dropdownList}
                                    style={{ width: '100%' }}
                                    optionLabel="dropdownValue"
                                    optionValue="dropdownValue"
                                    value={formData[label] || ''}
                                    onChange={(e) => handleChange(label, e.target.value, item.mandatory, item.elementType)}
                                    required={item.mandatory}
                                    errorMessage={errors[label]}
                                />
                            ) : ['int', 'docno', 'reqno', 'buyerpono', 'sellerpono', 'sellerpino', 'vpno', 'buyerinvoiceno'].includes(item.elementType.toLowerCase()) ? (
                                <TextInputField
                                    labelText={label}
                                    style={{ width: '100%' }}
                                    value={formData[label] || ''}
                                    onChange={(e) => handleChange(label, e.target.value, item.mandatory, item.elementType)}
                                    required={item.mandatory}
                                    errorMessage={errors[label]}
                                    keyfilter="pnum"
                                />
                            ) : (
                                <TextAreaField
                                    labelText={label}
                                    style={{ width: '100%' }}
                                    value={formData[label] || ''}
                                    onChange={(e) => handleChange(label, e.target.value, item.mandatory, item.elementType)}
                                    required={item.mandatory}
                                    errorMessage={errors[label]}
                                />
                            )}
                        </div>
                    </div>
                )
            })}

            <div style={{ width: '100%', textAlign: 'center', marginTop: '20px' }}>
                <Button
                    type="submit"
                    label="Continue"
                    className="p-button p-component"
                    style={{ width: '150px' }}
                    onClick={handleSubmit}
                />
            </div>
        </div>
    )
}

export default StructuredCommentModel
